import { useGetOne } from "react-admin";
import { Box } from "@mui/material";
import { useParams } from "react-router";

import {
  RazaUnifiedPrintContent,
  type RazaUnifiedPrintRecord,
} from "@/components/raza/RazaUnifiedPrintContent";

const HallBookingsRazaPrint = () => {
  const { id } = useParams<{ id: string }>();
  const { data: booking, isLoading: bookingLoading } = useGetOne("bookings", { id: id ?? "" });

  const razaRequestId =
    booking?.razaRequestId != null && String(booking.razaRequestId).trim() !== ""
      ? String(booking.razaRequestId).trim()
      : "";

  const { data: raza, isLoading: razaLoading } = useGetOne(
    "razaRequests",
    { id: razaRequestId },
    { enabled: Boolean(razaRequestId) }
  );

  if (bookingLoading || !booking) return <Box p={3}>...Loading</Box>;

  if (!razaRequestId) {
    return (
      <Box p={3}>
        This booking is not linked to a raza request; open the raza print from the raza request
        instead.
      </Box>
    );
  }

  if (razaLoading || !raza) return <Box p={3}>...Loading</Box>;

  return <RazaUnifiedPrintContent record={raza as RazaUnifiedPrintRecord} />;
};

export default HallBookingsRazaPrint;
